export default __webpack_public_path__ + "static/syncstage-built-to-be-cross-platform-49885743c7ca2871b8e96a1ebfb4771f.png";